import React from "react";
import {
  AutocompleteInput,
  EditProps,
  FormDataConsumer,
  ReferenceInput,
  required,
  SimpleForm,
} from "react-admin";
import { Grid } from "@material-ui/core";
import SanitizedGrid from "../../components/SanitizedGrid";
import CustomWaveInput from "../../components/CustomWaveInput";
import CustomRouteInput from "../../components/CustomRouteInput";
import CustomMonthPickerInput from "../../components/CustomMonthPickerInput";
import CustomEditToolbar from "../../components/CustomEditToolbar";
import EditWrapper from "../../components/EditWrapper";

const ExcludeBusAssistantEdit = (props: EditProps) => {
  const { id } = props;

  // Used to prevent select the past month
  const now = new Date();
  const currentMonth = now.getMonth() + 1; // getMonth() returns 0-based month (0 = Jan)
  const currentYear = now.getFullYear();

  const breadcrumb = [
    { title: "Exclude Bus Assistants", link: "/excludeBusAssistants" },
    { title: id, link: `/excludeBusAssistants/${id}` },
  ];

  return (
    <EditWrapper
      breadcrumb={breadcrumb}
      customNameWithId="Exclude Bus Assistant"
      {...props}
    >
      <SimpleForm toolbar={<CustomEditToolbar isShowDelete={false} />}>
      <SanitizedGrid container spacing={2}>
          <Grid item xs={4}>
            <ReferenceInput
              label="Subcontractor"
              source="subcontractorId"
              reference="subcontractors"
              validate={required()}
              disabled
            >
              <AutocompleteInput optionText="name" />
            </ReferenceInput>
          </Grid>
          <Grid item xs={8}></Grid>

          <Grid item xs={4}>
            <ReferenceInput
              label="School"
              source="schoolId"
              reference="schools"
              validate={required()}
              disabled
            >
              <AutocompleteInput optionText="name" />
            </ReferenceInput>
          </Grid>
          <Grid item xs={8}></Grid>

          <Grid item xs={4}>
            <CustomWaveInput isDisable isEdit isRequired />
          </Grid>
          <Grid item xs={8}></Grid>

          <Grid item xs={4}>
            <CustomRouteInput source="routeId" isDisable isEdit isRequired />
          </Grid>
          <Grid item xs={8}></Grid>

          <Grid item xs={4}>
            <FormDataConsumer>
              {({ formData }) => (
                <CustomMonthPickerInput
                  name="excludedMonth"
                  label="Excluded Month"
                  month={formData.month}
                  year={formData.year}
                  minMonth={currentMonth}
                  minYear={currentYear}
                  isRequired
                />
              )}
            </FormDataConsumer>
          </Grid>
          <Grid item xs={8}></Grid>
        </SanitizedGrid>
      </SimpleForm>
    </EditWrapper>
  );
};

export default ExcludeBusAssistantEdit;
